import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Clock } from "lucide-react";
import { Reveal } from "../components/site/Layout";
import {
  heroContent,
  aboutContent,
  services,
  stats,
  blogPosts,
  company,
} from "../data/mock";

const Home = () => {
  return (
    <>
      {/* HERO */}
      <section
        className="hero"
        style={{ backgroundImage: `url(${heroContent.image})` }}
      >
        <div className="hero-content">
          <h1 className="hero-title hero-anim-1">{heroContent.title}</h1>
          <h3 className="hero-subtitle hero-anim-2">{heroContent.subtitle}</h3>
          <div className="hero-anim-3">
            <Link to="/contact" className="btn-accent" data-testid="hero-cta">
              {heroContent.cta}
            </Link>
          </div>
        </div>
      </section>

      {/* DESPRE NOI */}
      <section className="section">
        <div className="site-container">
          <div className="about-grid">
            <Reveal>
              <div className="about-image">
                <img
                  src={aboutContent.image}
                  alt="Echipa Accent Prestări Servicii în birou"
                  loading="lazy"
                />
              </div>
            </Reveal>
            <Reveal delay={150}>
              <h2 className="section-title">{aboutContent.title}</h2>
              <p className="section-lead" style={{ marginBottom: 32 }}>
                {aboutContent.text}
              </p>
              <Link to="/despre-noi" className="btn-accent">
                {aboutContent.cta}
              </Link>
            </Reveal>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="stats-band">
        <div className="site-container">
          <div className="stats-grid">
            {stats.map((s, i) => (
              <Reveal key={s.label} delay={i * 120}>
                <div className="stat-value">{s.value}</div>
                <div className="stat-label">{s.label}</div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* SERVICII */}
      <section className="section section-soft-teal">
        <div className="site-container">
          <div className="services-home-grid">
            <Reveal>
              <h2 className="section-title">Servicii</h2>
              <p className="section-lead" style={{ marginBottom: 32 }}>
                Trei direcții principale, dezvoltate de peste 30 de ani:
                evidența primară, administrarea părții de personal și
                consilierea de management, acolo unde e nevoie de o
                decizie fundamentată. Documentele se transmit digital,
                pe drive.
              </p>
              <Link to="/servicii" className="btn-accent">
                Vezi toate serviciile
              </Link>
            </Reveal>
            <Reveal delay={120}>
              <div className="services-home-image">
                <img
                  src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
                  alt="Documente contabile și fișe de personal pe birou"
                  loading="lazy"
                />
              </div>
            </Reveal>
            <Reveal delay={200}>
              <div>
                {services.map((s) => (
                  <Link
                    key={s.id}
                    to="/servicii"
                    className="service-list-item"
                  >
                    {s.title}
                  </Link>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* NOUTĂȚI */}
      <section className="section">
        <div className="site-container">
          <Reveal>
            <h2 className="section-title" style={{ textAlign: "center" }}>
              Noutăți
            </h2>
            <p
              className="section-lead"
              style={{ textAlign: "center", margin: "0 auto 56px" }}
            >
              Articole pe teme relevante pentru administratori și
              antreprenori — documente primare, resurse umane, termene
              fiscale.
            </p>
          </Reveal>
          <div className="blog-grid">
            {blogPosts.map((p, i) => (
              <Reveal key={p.id} delay={i * 130}>
                <Link to={`/noutati/${p.slug}`} className="blog-card">
                  <div className="blog-card-image">
                    <img src={p.image} alt={p.title} loading="lazy" />
                  </div>
                  <div className="blog-card-meta">{p.category}</div>
                  <h3 className="blog-card-title">{p.title}</h3>
                  <p className="blog-card-excerpt">{p.excerpt}</p>
                  <span className="blog-card-more">Mai mult →</span>
                </Link>
              </Reveal>
            ))}
          </div>
          <Reveal>
            <div style={{ textAlign: "center", marginTop: 56 }}>
              <Link to="/noutati" className="btn-accent">
                Toate articolele
              </Link>
            </div>
          </Reveal>
        </div>
      </section>

      {/* CONTACT */}
      <section className="section section-soft-teal">
        <div className="site-container">
          <div className="contact-grid">
            <Reveal>
              <h2 className="section-title">Contact</h2>
              <p className="section-lead" style={{ marginBottom: 24 }}>
                Pentru o ofertă sau o întrebare punctuală, cel mai rapid
                canal este telefonul. WhatsApp-ul funcționează la fel de
                bine — răspundem în timp util, direct.
              </p>
              <div className="home-contact-info">
                <div className="contact-info-card">
                  <div className="contact-info-icon">
                    <Phone size={21} />
                  </div>
                  <div>
                    <h4>Telefon</h4>
                    <a href={`tel:${company.phoneHref}`} data-testid="home-phone">
                      {company.phone}
                    </a>
                  </div>
                </div>
                <div className="contact-info-card">
                  <div className="contact-info-icon">
                    <Mail size={21} />
                  </div>
                  <div>
                    <h4>Email</h4>
                    <a
                      href={`mailto:${company.email}`}
                      className="email-link"
                      data-testid="home-email"
                    >
                      {company.email}
                    </a>
                  </div>
                </div>
                <div className="contact-info-card">
                  <div className="contact-info-icon">
                    <Clock size={21} />
                  </div>
                  <div>
                    <h4>Program</h4>
                    <p>{company.schedule}</p>
                  </div>
                </div>
              </div>
              <Link
                to="/contact"
                className="btn-accent"
                style={{ marginTop: 28 }}
              >
                Vezi contactul complet
              </Link>
            </Reveal>
            <Reveal delay={150}>
              <div className="contact-side-image">
                <img
                  src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
                  alt="Discuție de lucru între specialiști"
                  loading="lazy"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
